module.exports = __webpack_public_path__ + "images/stickers/taco-money.6d9f9a68e15d9a56f5cf.png";